import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  margin-bottom: 20px;

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    list-style: none;

    li {
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
      }

      span {
        font-size: 2rem;
      }

      &:not(:last-of-type) {
        margin-right: 40px;
      }
    }

    ${breakpoints.down('xs')} {
      li {
        p {
          font-size: 1.6rem;
        }

        span {
          font-size: 1.8rem;
        }
      }
    }
  }

  .item {
    &--mbRating {
      .scores__img {
        font-size: 3.8rem;
        height: auto;
        margin-right: 5px;
      }
    }
  }

  &.scores {
    &--card {
      margin-top: 5px;
      margin-bottom: 5px;

      ul {
        justify-content: space-between;

        li {
          margin-right: 0;

          p {
            font-size: 1.2rem;
            line-height: 1.6rem;

            span {
              font-size: 1.4rem;
            }
          }

          img {
            max-width: 41px;
            margin-right: 4px;
          }
        }
      }

      .item {
        &--imdb {
          img {
            max-width: 30px;
          }
        }
      }
    }
  }
`;

export default Container;
